(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = document.documentElement.classList.contains('shopify-design-mode') || (window.Shopify && Shopify.designMode);
  if (design) document.documentElement.classList.add('hc-design-mode');

  // announcement height for sticky header offset
  function setAnnounce() {
    var a = document.querySelector('.hc-announce');
    document.body.style.setProperty('--hc-announce-h', (a ? a.offsetHeight : 0) + 'px');
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, sib = [].slice.call(el.parentNode.children).filter(function (c) { return c.classList.contains('hc-reveal'); });
      el.style.transitionDelay = (Math.max(0, sib.indexOf(el)) * 70) + 'ms';
      el.classList.add('is-in'); io.unobserve(el);
    });
  }, { threshold: .12, rootMargin: '0px 0px -6% 0px' }) : null;

  function countUp(el) {
    var to = +el.dataset.count, t0 = null, d = 1100;
    if (reduce || to === 0 || design) { el.textContent = to; return; }
    function step(t) { t0 = t0 || t; var p = Math.min(1, (t - t0) / d); el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var cio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { cio.unobserve(e.target); countUp(e.target); } });
  }, { threshold: .6 }) : null;

  function initHotspots(root) {
    if (root.dataset.hcInit) return; root.dataset.hcInit = '1';
    var hots = [].slice.call(root.querySelectorAll('.hc-hot')),
      panels = [].slice.call(root.querySelectorAll('.hc-panel')),
      dots = [].slice.call(root.querySelectorAll('.hc-dots i')), cur = 0, timer;
    if (!hots.length) return;
    function show(i) { cur = i; [hots, panels, dots].forEach(function (g) { g.forEach(function (n, k) { n.classList.toggle('is-active', k === i); }); }); }
    function stop() { clearInterval(timer); }
    hots.forEach(function (h, i) { h.addEventListener('click', function () { show(i); stop(); }); h.addEventListener('mouseenter', function () { show(i); stop(); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); stop(); }); });
    show(0);
    if (!reduce && !design && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { stop(); if (e.isIntersecting) timer = setInterval(function () { show((cur + 1) % hots.length); }, 3200); }); }, { threshold: .4 }).observe(root);
    }
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('.hc-reveal').forEach(function (el) { if (design || !io) el.classList.add('is-in'); else io.observe(el); });
    scope.querySelectorAll('[data-count]').forEach(function (el) { if (cio && !design) cio.observe(el); else el.textContent = el.dataset.count; });
    scope.querySelectorAll('.hc-anatomy').forEach(initHotspots);
    scope.querySelectorAll('.hc-closer').forEach(function (c) {
      if (design || !('IntersectionObserver' in window)) { c.classList.add('is-in'); return; }
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) c.classList.add('is-in'); }); }, { threshold: .3 }).observe(c);
    });
    setAnnounce();
  }

  // header state + hero parallax
  var mx = 0, my = 0;
  function onScroll() {
    var pw = document.querySelector('.page-wrapper'); var y = Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0), header = document.querySelector('.hc-header');
    if (header) header.classList.toggle('is-scrolled', y > 10);
    if (reduce) return;
    document.querySelectorAll('.hc-hero [data-depth]').forEach(function (el) {
      var d = +el.dataset.depth;
      el.style.transform = 'translate(' + (mx * d * 60) + 'px,' + (y * d * -0.6 + my * d * 60) + 'px)' + (el.classList.contains('hc-hero__packet') ? ' rotate(-6deg)' : '');
    });
    document.querySelectorAll('[data-hc-parallax]').forEach(function (par) {
      var r = par.parentNode.getBoundingClientRect();
      var p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      par.style.transform = 'translateY(' + (p * -9) + '%)';
    });
  }
  document.addEventListener('scroll', function () { requestAnimationFrame(onScroll); }, { passive: true, capture: true });
  addEventListener('resize', setAnnounce);
  document.addEventListener('pointermove', function (e) {
    var stage = e.target.closest && e.target.closest('.hc-hero__stage');
    if (!stage) { if (mx || my) { mx = my = 0; onScroll(); } return; }
    var r = stage.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width - .5; my = (e.clientY - r.top) / r.height - .5; onScroll();
  });

  // newsletter: show inline success
  document.addEventListener('DOMContentLoaded', function () { init(); onScroll(); });
  if (document.readyState !== 'loading') { init(); onScroll(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); onScroll(); });
})();
